var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dynamicContentDiv",
    style: {
      flexDirection: _vm.dynamicContent.layout === 'COLUMN' ? 'column' : 'row'
    }
  }, _vm._l(_vm.dynamicContent.items, function (item, index) {
    return _c('div', {
      class: ['dynamicContentItem', {
        image: item.image
      }]
    }, [item.textHtml ? _c('html-renderer', {
      attrs: {
        "htmlObject": item.textHtml
      }
    }) : item.image && item.image.image && item.image.image.src ? _c('img', {
      staticClass: "image",
      attrs: {
        "src": item.image.image.src
      }
    }) : item.table ? _c('div', {
      staticClass: "tableSection"
    }, [_c('activity-table', {
      attrs: {
        "tableData": item.table
      }
    })], 1) : item.scrollableText ? _c('div', {
      staticClass: "scrollableTextSection",
      style: {
        height: ((item.scrollableText.height ? item.scrollableText.height : 330) + "px"),
        width: ((item.scrollableText.width ? item.scrollableText.width : 330) + "px")
      }
    }, [_c('html-renderer', {
      attrs: {
        "htmlObject": item.scrollableText.textHtml
      }
    })], 1) : item.dynamicContent ? _c('dynamic-content', {
      attrs: {
        "dynamicContent": item.dynamicContent
      }
    }) : _vm._e()], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }